import { Box, Typography, Grid } from "@mui/material";
import { useTheme } from "@mui/material";
import { formatDates } from "../../../utilities/helpers";

/** Lines are formatted as "email - Role"; Supervisor rows are omitted from the report. */
const getParticipantsExcludingSupervisor = (participantsText) => {
  if (!participantsText?.trim()) return [];
  return participantsText
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => {
      if (!line) return false;
      const parts = line.split(" - ");
      if (parts.length < 2) return true;
      const role = parts[parts.length - 1].trim();
      return role.toLowerCase() !== "supervisor";
    });
};

const AdministrativeReport = ({ formData }) => {
  const theme = useTheme();
  const participantLines = getParticipantsExcludingSupervisor(formData.participants);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.alt,
        p: "1rem",
        borderRadius: "0.55rem",
        mb: "1rem",
      }}
    >

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">Inspected Firm</Typography>
          <Typography variant="body1">{formData.inspectedFirm || "-"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">Location</Typography>
          <Typography variant="body1">{formData.location || "-"}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1" color="text.secondary">Phone</Typography>
          <Typography variant="body1">{formData.phone || "-"}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1" color="text.secondary">Fax</Typography>
          <Typography variant="body1">{formData.fax || "-"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">Mailing Address</Typography>
          <Typography variant="body1">{formData.mailingAddress || "-"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">Dates of Inspection</Typography>
          <Typography variant="body1">{formatDates(formData.inspectionDates)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1" color="text.secondary">Days in the Facility</Typography>
          <Typography variant="body1">{formData.daysInFacility || "-"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">Participants</Typography>
          {participantLines.length > 0
            ? participantLines.map((line, idx) => (
                <Typography key={idx} variant="body1">{line}</Typography>
              ))
            : <Typography variant="body1">-</Typography>
          }
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdministrativeReport; 